import { render, staticRenderFns } from "./NotificationSettingList.vue?vue&type=template&id=16b609a0&"
import script from "./NotificationSettingList.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports